<template>
  <el-row class="articleContent">
    <el-col :span="24">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/industry-manage' }"
          >行业监管</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ regulations.laws }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div
        class="articleContent-context"
        style="
          border-radius: 4px;
          border: 1px solid #e6ebf5;
          padding: 20px 20px 10px;
        "
      >
        <div class="grid-content bg-purple-dark">
          <p>{{ regulations.laws }}</p>
          <div class="hxl_title"></div>
        </div>
        <div class="announcement">
          <div class="ipt">
            <el-input
              v-model="searchOn"
              maxlength="24rem"
              placeholder="标准名称/标准号"
              class="input-with-select"
            >
              <el-button
                class="searchFor"
                slot="append"
                size="small"
                @click="seeSer()"
                >搜索</el-button
              >
            </el-input>
            <el-button size="small" class="reset" @click="resetOn()"
              >重置</el-button
            >
          </div>
          <div class="dat">
            <div class="paging">
              <el-select v-model="data" class="sele" @change="dataChange()">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>

              <el-date-picker
                popper-class="timeclass"
                class="timeSta"
                v-model="timeSta"
                type="date"
                placeholder="开始时间"
                @change="timeStaChange()"
              >
              </el-date-picker>
              <span style="font-size: 16px; margin-left: 5px; margin-right: 5px"
                >至</span
              >
              <el-date-picker
                popper-class="timeclass"
                class="timeSta"
                v-model="timeEnd"
                type="date"
                placeholder="结束时间"
                @change="timeEndChange()"
              >
              </el-date-picker>

              <el-select
                v-model="state"
                clearable
                placeholder="标准状态"
                class="sele"
                @change="stateChange()"
              >
                <el-option
                  v-for="item in stateList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>

              <el-select
                v-model="nature"
                clearable
                placeholder="标准性质"
                class="sele"
                @change="natureChange()"
              >
                <el-option
                  v-for="item in natureList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </div>
            <div>
              <el-button
                size="small"
                icon="el-icon-refresh"
                class="refresh"
                @click="refresh()"
                >刷新</el-button
              >
            </div>
          </div>
          <div style="text-align: center; margin-top: 5px">
            <el-table
              :data="legalForms"
              :stripe="true"
              border
              fit
              style="width: 100%"
              :header-cell-style="{
                background: '#ebe6db',
                color: '#585856',
                borderColor: '#585856',
              }"
              :cell-style="{ borderColor: '#585856' }"
            >
              <el-table-column
                align="center"
                type="index"
                :index="count"
                label="序号"
                width="60"
              >
              </el-table-column>
              <el-table-column
                align="center"
                prop="standardNum"
                label="标准号"
                min-width="140px"
              >
              </el-table-column>
              <el-table-column
                align="center"
                prop="title"
                label="标准名称"
                min-width="140px"
              >
                <template slot-scope="scope">
                  <!-- <span>{{ scope.row.title }}</span> -->
                  <span @click="runTitle(scope.row.id)" class="titleSpan">{{
                    scope.row.title
                  }}</span>
                  <!--                  <span-->
                  <!--                          v-else-->
                  <!--                          style="-->
                  <!--                    color: #4b74ff;-->
                  <!--                    text-decoration: underline;-->
                  <!--                    font-size: 14px;-->
                  <!--                    cursor: pointer;-->
                  <!--                    "-->
                  <!--                          @click="showPDF(scope.row.url)"-->
                  <!--                  >{{scope.row.title}}</span>-->
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="publishingDate"
                label="发布日期"
                min-width="140px"
              >
                <template slot-scope="scope">{{
                  scope.row.publishingDate | formatDate
                }}</template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="executeDate"
                label="实施日期"
                min-width="140px"
              >
                <template slot-scope="scope">{{
                  scope.row.executeDate | formatDate
                }}</template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="standardNatureName"
                label="标准性质"
                min-width="100px"
              >
              </el-table-column>
              <el-table-column
                align="center"
                prop="standardStatusName"
                label="标准状态"
                min-width="100px"
              >
              </el-table-column>
              <el-table-column
                align="center"
                prop="publishingBody"
                label="发布机构"
                min-width="140px"
              >
              </el-table-column>
            </el-table>
            <el-pagination
              popper-class="pageclass"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 40, 80]"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import {
  URL_INDUSTRY_BZGF_FIND,
  URL_COMPREHENSIVE_EXCUSE,
} from "../../utils/api";
import util from "../../utils/util";
import { frontHeater } from "../../utils/md5encryption";
export default {
  inject: ["reload"],
  props: [],
  components: {},
  data() {
    return {
      // 基本数据
      regulations: {
        //  标题+面包屑
        laws: "标准规范",
      },
      //   下拉列表
      options: [
        {
          value: "发布日期",
          label: "发布日期",
        },
        {
          value: "实施日期",
          label: "实施日期",
        },
      ],
      stateList: [],
      natureList: [],
      pdfUrl: "",
      //  选择框model
      data: "发布日期",
      //标准状态
      state: null,
      //标准性质
      nature: null,
      //   开始时间
      timeSta: null,
      // 结束时间
      timeEnd: null,
      //   搜索
      searchOn: null,
      // 法律法规 表格
      legalForms: [],
      // 前往页数
      currentPage: 1,
      // 总条数
      total: 100,
      pagesize: 10,
    };
  },
  computed: {},
  filters: {
    formatDate: function (value) {
      if (value != undefined) {
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        return y + "年" + MM + "月" + d + "日";
      }
    },
  },
  mounted() {
    this.getList();
    this.getXingzhiList();
    this.getZhuangtaiList();
  },
  methods: {
    // 请求数据
    getList() {
      let Url = util.getAjaxUrl("axiosThree");
      let params;
      if (this.data == "发布日期") {
        let result = frontHeater(
          ["standardStatusCode", "standardNatureCode"],
          [this.state, this.nature]
        );
        params = {
          keyWord: this.searchOn,
          publishingDateStart: this.timeSta,
          publishingDateEnd: this.timeEnd,
          standardStatusCode: this.state,
          standardNatureCode: this.nature,
          pageNation: { pageNumber: this.currentPage, pageSize: this.pagesize },
        };
        this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
        this.$http.defaults.headers.common["secretSign"] =
          result.encryptionString;
        this.$http.defaults.headers.common["secretDefinite"] =
          result.parameterKey;
        this.$http.defaults.headers.common["appCode"] = result.secret;
        this.$http.defaults.headers.common["standardStatusCode"] = this.state;
        this.$http.defaults.headers.common["standardNatureCode"] = this.nature;
      } else {
        let result = frontHeater(
          ["standardStatusCode", "standardNatureCode"],
          [this.state, this.nature]
        );
        params = {
          keyWord: this.searchOn,
          standardStatusCode: this.state,
          standardNatureCode: this.nature,
          executeDateStart: this.timeSta,
          executeDateEnd: this.timeEnd,
          pageNation: { pageNumber: this.currentPage, pageSize: this.pagesize },
        };
        this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
        this.$http.defaults.headers.common["secretSign"] =
          result.encryptionString;
        this.$http.defaults.headers.common["secretDefinite"] =
          result.parameterKey;
        this.$http.defaults.headers.common["appCode"] = result.secret;
        this.$http.defaults.headers.common["standardStatusCode"] = this.state;
        this.$http.defaults.headers.common["standardNatureCode"] = this.nature;
      }
      this.$http.post(Url + URL_INDUSTRY_BZGF_FIND, params).then((res) => {
        if (res.status == 200) {
          this.legalForms = res.data.data.data;
          this.total = res.data.data.pagination.totalNum;
        }
      });
    },
    // 请求标准状态数据
    getZhuangtaiList() {
      let result = frontHeater(["ClassCode"], ["StandardStatusCode"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        ClassCode: "StandardStatusCode",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["ClassCode"] = "StandardStatusCode";
      this.$http.post(Url + URL_COMPREHENSIVE_EXCUSE, params).then((res) => {
        if (res.status == 200) {
          this.stateList = res.data.data;
        }
      });
    },
    // 请求标准性质数据
    getXingzhiList() {
      let result = frontHeater(["ClassCode"], ["StandardNatureCode"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        ClassCode: "StandardNatureCode",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["ClassCode"] = "StandardNatureCode";
      this.$http.post(Url + URL_COMPREHENSIVE_EXCUSE, params).then((res) => {
        if (res.status == 200) {
          console.log(res);
          let params = {
            id: "50004",
            name: "全部",
            code: "",
          };
          this.natureList = res.data.data;
          this.natureList.unshift(params);
        }
      });
    },
    // 搜索
    seeSer() {
      this.getList();
    },
    //打开pdf
    runTitle(ids) {
      let Url = util.getAjaxUrl("axiosFour");
      this.$http
        .get(Url + "/portal/industry/bzgf/download?id=" + ids, {
          responseType: "blob",
        })
        .then((res) => {
          this.pdfUrl = this.getObjectURL(res.data);
          //  在新的页面打开
          let routerJump = this.$router.resolve({
            path: "/pdfStandard",
            query: {
              pdfUrl: this.pdfUrl,
            },
          });
          window.open(routerJump.href, "_blank");
        });
    },
    // 将返回的流数据转换为url
    getObjectURL(file) {
      let url = null;
      if (window.createObjectURL != undefined) {
        // basic
        url = window.createObjectURL(file);
      } else if (window.webkitURL != undefined) {
        // webkit or chrome
        try {
          url = window.webkitURL.createObjectURL(file);
        } catch (error) {}
      } else if (window.URL != undefined) {
        // mozilla(firefox)
        try {
          url = window.URL.createObjectURL(file);
        } catch (error) {}
      }
      return url;
    },
    // 重置
    resetOn() {
      this.searchOn = null;
      this.data = "发布日期";
      this.timeSta = null;
      this.timeEnd = null;
      this.state = null;
      this.nature = null;
      this.currentPage = 1;
      this.getList();
    },
    // 刷新
    refresh() {
      this.resetOn();
    },
    // 解决换页后index从1开始
    count(index) {
      return (this.currentPage - 1) * this.pagesize + index + 1;
    },
    // 确定页数
    handleSizeChange(val) {
      this.pagesize = val;
      this.getList();
    },
    // 当前页数
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    natureChange() {
      this.getList();
    },
    stateChange() {
      this.getList();
    },
    timeEndChange() {
      this.getList();
    },
    timeStaChange() {
      this.getList();
    },
    dataChange() {
      console.log(this.data);
    },
    showPDF(url) {
      let Url = util.getAjaxUrl("axiosOne");
      window.open(Url + url);
    },
  },
};
</script>
<style scoped lang='less'>
@import "../../styles/theme";
@import "../../styles/comSty";
/deep/ .el-breadcrumb {
  margin-top: -10px;
  margin-bottom: 10px;
}
/deep/ .announcement {
  border: none;
}
/deep/ .el-input__inner {
  font-size: 16px !important;
}
/deep/ .el-button {
  font-size: 16px !important;
}
/deep/ .el-breadcrumb {
  font-size: 16px;
}
.articleContent {
  padding: 20px;
}
.ipt {
  margin-top: 10px;
}
.refresh {
  height: 100%;
}
p {
  font-size: 18px;
  font-weight: 700;
  color: #b71c1c;
  margin: 10px 0;
  text-align: center;
}
.titleSpan {
  cursor: pointer;
  text-decoration: underline;
}
.hxl_title {
  font-size: 22px;
  padding-bottom: 10px;
  color: #b71c1c;
  border-bottom: 3px solid #b71c1c;
}
.sele {
  width: 140px;
  height: 32px;
}
.timeSta {
  width: 160px;
  height: 32px;
}
.dat {
  display: flex;
  justify-content: space-between;
  /*padding: 0 20px;*/
  margin: 10px 0;
}
</style>
